export function createMailtoLink(subject, body) {
  // Encode special characters and replace HTML tags with entities
  // const encodedBody = body
  //     .replace(/&/g, '&amp;')
  //     .replace(/<br>/g, '&lt;br&gt;')
  //     .replace(/</g, '&lt;')
  //     .replace(/>/g, '&gt;')
  //     .replace(/"/g, '&quot;')
  //     .replace(/\n/g, '%0D%0A'); // Add line breaks

  return `mailto:info@gsmgroup.africa?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function createWhatsappQuotationLink(subject, body) {
  // Encode special characters and replace HTML tags with entities
  // const encodedBody = body
  //     .replace(/&/g, '&amp;')
  //     .replace(/<br>/g, '&lt;br&gt;')
  //     .replace(/</g, '&lt;')
  //     .replace(/>/g, '&gt;')
  //     .replace(/"/g, '&quot;')
  //     .replace(/\n/g, '%0D%0A'); // Add line breaks

  return `https://wa.me/255745000000?text=${encodeURIComponent(body)}`;
  // return `mailto:info@nyatiferniture.co.tz?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(encodedBody)}`;
}